<ng-container>
  <ng-container *ngFor="let obj of customObjects">
    <ng-container *ngIf="obj.component == 'notification_banner'">
      <div class="govuk-notification-banner app-notification-banner" role="region" aria-labelledby="govuk-notification-banner-title"
        data-module="govuk-notification-banner">
        <div class="govuk-notification-banner__header">
          <h2 class="govuk-notification-banner__title" id="govuk-notification-banner-title">
            {{obj.slug}}
          </h2>
        </div>
        <div class="govuk-notification-banner__content">
          <p class="govuk-notification-banner__heading" [innerHTML]="obj.body">
          </p>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="obj.component == 'inset_text'">
      <p class="govuk-inset-text" [innerHTML]="obj.body"></p>
    </ng-container>
  </ng-container>
</ng-container>